import { useSelector } from "react-redux";
import type { BigNumber as BigNumberType } from "bignumber.js";
import {
  feeV3,
  permit2,
  privatekeyArray,
  quoter,
  router,
  slippage,
  spenToken,
  swapType,
  token,
} from "@/store";
import { QuoterV2, PancakeRouterABI, SwapABI, Flap } from "@/config";
import { useProviderInstance } from '@/context/ProviderContext';
import { useExecuteSwapWithFee } from "./executeSwapWithFee";
import { getContract, parseEther } from "viem";
import { to0xString } from "@/utils/toHex";
export default function executeSwap() {
  const _swapType = useSelector(swapType);
  const _spenToken = useSelector(spenToken);
  const _quoter = useSelector(quoter);
  const provider = useProviderInstance();
  const _slippage = useSelector(slippage);
  const _feeV3 = useSelector(feeV3);
  const _router = useSelector(router);
  const _permit2 = useSelector(permit2);
  const _token = useSelector(token);

  const { getPathBytes } = useExecuteSwapWithFee();
  // const getV4SlippageAmount = async (
  //   amountIn: BigNumber,
  //   tradeMethods: boolean,
  //   poolKeyArray: string[],
  // ) => {
  //   const quoter = new ethers.Contract(_quoter, ClQuoter, provider);
  //   const quoteParams = [
  //     poolKeyArray,
  //     tradeMethods,
  //     ethers.BigNumber.from(amountIn),
  //     "0x",
  //   ];
  //   console.log("quoteParams::: ", quoteParams);
  //   console.log("quoter::: ", quoter);

  //   const [amountOut, gasEstimate] =
  //     await quoter.callStatic.quoteExactInputSingle(quoteParams);
  //   console.log(
  //     "amountOut, gasEstimate::: ",
  //     Number(amountOut),
  //     Number(gasEstimate),
  //   );
  //   return [amountOut, gasEstimate];
  // };
  const calculateSlippageAmount = async (
    path: string[],
    publicClient: any,
    amountIn: bigint,
    isBuy: boolean,
    poolKeyArray: string[],
    _newSlippage?: string,
  ) => {
    try {
      let slippageAmount: bigint;
      const finallySlippage = _newSlippage || _slippage;
      switch (_swapType) {
        // case "V4": {
        //   console.log(
        //     "amountIn, swapMethods, poolKeyArray::: ",
        //     amountIn,
        //     poolKeyArray,
        //   );

        //   const Methods = poolKeyArray[0] == _spenToken.address;
        //   const swapMethods = Methods ? isBuy : !isBuy;
        //   const result = await getV4SlippageAmount(
        //     amountIn,
        //     swapMethods,
        //     poolKeyArray,
        //   );
        //   console.log("result::: ", result);
        //   // console.log('amountIn::: ', amountIn);

        //   const amountOut = result[0];

        //   const slippage_ = 10000 - Number(finallySlippage) * 100;

        //   const _getAmount: BigNumber = BigNumber.from(amountOut);

        //   slippageAmount = _getAmount
        //     .mul(BigNumber.from(slippage_))
        //     .div(BigNumber.from(10000));
        //   // console.log('slippageAmount::: ', Number(slippageAmount));

        //   break;
        // }
        case "V3":
          {
            // const quoter = new ethers.Contract(_quoter, QuoterV2, provider);
            const quoter = getContract({
              address: to0xString(_quoter),
              abi: QuoterV2,
              client: provider
            }) as any
            const fee = Number(_feeV3) * 10000;

            let pathBytes = await getPathBytes(path, fee.toString(), isBuy);

            const result = await quoter.read.quoteExactInput([
              pathBytes,
              amountIn,
            ]);
            console.log(result, "result");
            const amountOut = result[0];

            const slippage_ = 10000 - Number(finallySlippage) * 100;

            slippageAmount =
              (amountOut * BigInt(slippage_)) / 10000n;
          }
          break;

        case "four":
          {
            const _tokenInfos = await publicClient.readContract({
              address: to0xString(_permit2),
              abi: SwapABI,
              functionName: '_tokenInfos',
              args: [_token?.address],
            })
            const lastPrice = _tokenInfos[9];
            console.log('_tokenInfos::: ', _tokenInfos);
            console.log('lastPrice::: ', lastPrice);

            if (isBuy) {
              const _amount = (amountIn * parseEther("1")) / lastPrice;
              slippageAmount =
                (_amount * BigInt(100 - Number(finallySlippage))) / 100n;
            } else {
              const _amount = (amountIn * lastPrice) / parseEther("1");
              slippageAmount =
                (_amount * BigInt(100 - Number(finallySlippage))) / 100n;
            }
          }
          break;
        case "flap":
          {
            let info: bigint;
            if (isBuy) {
              info = await publicClient.readContract({
                address: to0xString(_quoter),
                abi: Flap,
                functionName: "calculateOutput",
                args: [
                  to0xString(_spenToken?.address),
                  to0xString(_token?.address),
                  amountIn,
                ],
              }) as bigint;
            } else {
              info = await publicClient.readContract({
                address: to0xString(_quoter),
                abi: Flap,
                functionName: "calculateOutput",
                args: [
                  to0xString(_token?.address),
                  to0xString(_spenToken?.address),
                  amountIn,
                ],
              }) as bigint;
            }

            slippageAmount =
              (info * BigInt(100 - Number(finallySlippage))) / 100n;
          }
          break;
        default:
            console.log('amountIn::: ', amountIn);

          const amounts = await publicClient.readContract({
            address: to0xString(_router.address),
            abi: PancakeRouterABI,
            functionName: 'getAmountsOut',
            args: [amountIn, path],
          })
          const amountOut = path.length === 2
            ? amounts[1]
            : amounts[2];

          const slippageBps = BigInt(
            Math.round(Number(finallySlippage) * 100)
          );
          slippageAmount = (amountOut * (10000n - slippageBps)) / 10000n;

          break;
      }

      return slippageAmount;
    } catch (error) {
      console.error("滑点计算错误:", error);
      throw error;
    }
  };
  // 兑换一定代币所需的输入代币金额

  const trageLimitNeedETH = (
    value: bigint,
    path: string[],
    isBuy: boolean,
    poolKeyArray: string[],
    publicClient: any
  ) => {
    return new Promise(async (resolve: (amount: bigint) => void, reject) => {
      try {
        switch (_swapType) {
          case "V3":
            {
              // const quoter = new ethers.Contract(_quoter, QuoterV2, provider);
              const quoter = getContract({
                address: to0xString(_quoter),
                abi: QuoterV2,
                client: provider,
              }) as any;
              //  const amounts = await publicClient.readContract({
              //   address: to0xString(_quoter),
              //   abi: QuoterV2,
              //   functionName: 'quoteExactOutputSingle',
              //   args: [value, path],
              // })
              const fee = Number(_feeV3) * 10000;
              const params = {
                tokenIn: path[0],
                tokenOut: path[1],
                amount: value,
                fee: fee,
                sqrtPriceLimitX96: 0,
              };
              const result = await quoter.read.quoteExactOutputSingle([params]);
              console.log("result", result)
              resolve(result[0]);
            }
            break;

          case "flap":
            {
              //不能实现
            }
            break;
          case "four":
            {
              const amounts = await publicClient.readContract({
                address: to0xString(_router.address),
                abi: PancakeRouterABI,
                functionName: 'getAmountsIn',
                args: [value, path],
              })
              resolve(amounts[0]);
            }
            break;
          case "V4":
            {
              // const res = await getV4SlippageAmount(value, isBuy, poolKeyArray);
              // resolve(res[1]);
            }
            break;
          default:
            {
              const amounts = await publicClient.readContract({
                address: to0xString(_router.address),
                abi: PancakeRouterABI,
                functionName: 'getAmountsIn',
                args: [value, path],
              })
              resolve(amounts[0]);
            }
            break;
        }
      } catch (error) {
        console.log(error, "err");
        reject(error);
      }
    });
  };
  return { calculateSlippageAmount, trageLimitNeedETH };
}
